import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const BlogList = () => {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        fetch('https://blogs.eyantra.com/wp-json/wp/v2/posts?_embed=1&per_page=100')
            .then(res => res.json())
            .then(data => setPosts(data))
            .catch(err => console.error('Error fetching posts:', err));
    }, []);

    return (<>
        <div className='container-fluid mt-4' id='bgBlog' style={{ backgroundImage: "url(./assests/blogBg.png)", height: '300px', backgroundSize: 'cover' }}>
            <Container className="h-100">
                <div className='d-flex justify-content-center align-items-center flex-column h-100 text-center'>
                    <h1 className='fs-48 fw-bold'>Blogs</h1>
                    <p className='text-center'>
                        Read the latest articles, blogs, case studies, and many more published by eYantra
                    </p>
                </div>
            </Container>
        </div>
        <div className='container-fluid bg-light'>
            <Container>

                <Row className="py-5">
                    {posts.map(post => (
                        
                        <Col md={4} key={post.id}>
                            <Link to={`/blog/${post.slug}`} className='text-decoration-none'>
                            <div className="card bg-transparent border-0">
                                <div className="ratio ratio-16x9 overflow-hidden rounded-top">
                                    <img src={post._embedded?.['wp:featuredmedia']?.[0]?.source_url || './assests/blogBg.png'}
                                        className="w-100 h-100 object-fill-cover border-eY rounded" alt="Blog Image" />
                                </div>
                                <div className="card-body px-0 py-4">

                                    <h5 className="card-title fw-bold fs-5" dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
                                    <p className="card-text text-truncate-multiline">
                                        <div dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }} />
                                    </p>
                                    <Row className='align-items-baseline justify-content-between'>
                                        <Col md={7}>
                                            <p className="mb-0 p-0">{post._embedded?.author?.[0]?.name}</p>
                                            <p className="text-muted small p-0 m-0">{new Date(post.date).toLocaleDateString()}</p>
                                        </Col>
                                        <Col md={5} className='text-end'>
                                            <Link to={`/blog/${post.slug}`} >
                                                <button className='bg-transparent px-3 py-1 rounded-pill'>
                                                    Read More
                                                </button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            </Link>


                        </Col>
                    ))}

                </Row>

            </Container>
        </div>
    </>
    );
};

export default BlogList;
